import { Table, TableBody, TableHead, TableRow } from "@mui/material";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { StyledTableCell } from "../styles";
import { MultiCalculationRow, MultiCalculationRowHeader } from "../types";

type Props = {
  rows: MultiCalculationRow[];
};

const AccumulationsTableMultiCalculationTable = ({ rows }: Props) => {
  const { t } = useTranslation("talentProfile");

  const headers: MultiCalculationRowHeader[] = [
    { key: "valueDate", label: t("accumulationKeys.valueDate") },
    { key: "salary", label: t("accumulationKeys.salary") },
    { key: "workTime", label: t("accumulationKeys.workTimeMulti") },
  ];

  const renderValue = (key: string, value?: string | number) => {
    if (key === "valueDate" && value) {
      return format(new Date(value), "dd.MM.yyyy");
    }
    return value !== undefined && value !== null ? value : "0";
  };

  return (
    <StyledTableCell>
      <Table>
        <TableHead>
          <TableRow>
            {headers.map((header) => (
              <StyledTableCell key={header.key} align="right">
                {header.label}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={`TableRow_${index}`}>
              {headers.map((header) => (
                <StyledTableCell key={header.key} align="right">
                  {renderValue(header.key, row[header.key])}
                </StyledTableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </StyledTableCell>
  );
};

export default AccumulationsTableMultiCalculationTable;
